import { FieldName, FormValues } from 'types/form';

// Store Search Form
export const SearchBoxFormFields = {
  query: 'query' as FieldName<string>,
};

export enum LoadingKinds {
  DOTS = 'DOTS',
  RADIAL = 'RADIAL',
  PHASER = 'PHASER',
}

export type SearchBoxFormValues = FormValues<typeof SearchBoxFormFields>;
